// extracted by mini-css-extract-plugin
export default {"focus_locked_acord_130_main_container":"Acord130_focus_locked_acord_130_main_container__Mth63"};